<span class="user-avatar-image" [ngStyle]="{ 'background-image': 'url(' + logoUrl + ')' }"></span>
